import { FC, useContext } from 'react';

import {
  BonusIcon,
  CircleCloseIcon,
  ClockIcon,
  HandCoinIcon,
  PrinterIcon,
  ShopIcon,
  Table,
} from '@smartshell/ui-kit';

import { SummaryBlock } from 'components';
import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';

import { useColumns } from '../useColumns';
import { formatDuration, formatMoney } from '../utils';
import s from '../WorkShifts.module.scss';
import { ISummaryBlocksProps } from './interfaces';

export const SummaryBlocks: FC<ISummaryBlocksProps> = ({ total, summary }) => {
  const {
    state: {
      settings: {
        currency: { sign: currency },
      },
    },
  } = useContext(SettingsContext);
  const { t } = useContext(LocalizationContext);

  const COLUMNS = useColumns();

  return (
    <>
      <div className={s.summary}>
        <SummaryBlock
          Icon={ClockIcon}
          color="gray"
          topText={formatDuration(total.duration, t)}
          bottomText={t('report.workShift.duration')}
        />
        <SummaryBlock
          Icon={HandCoinIcon}
          color="gray"
          topText={formatMoney(total.proceeds, currency)}
          bottomText={t('money.proceeds')}
        />
        <SummaryBlock
          Icon={ShopIcon}
          color="gray"
          topText={formatMoney(total.goods, currency)}
          bottomText={t('report.workShifts.totals.goods')}
        />
        <SummaryBlock
          Icon={PrinterIcon}
          color="gray"
          topText={formatMoney(total.services, currency)}
          bottomText={t('report.workShifts.totals.services')}
        />
        <SummaryBlock
          Icon={BonusIcon}
          color="orange"
          topText={formatMoney(total.bonuses, currency)}
          bottomText={t('report.workShifts.totals.bonuses')}
        />
        <SummaryBlock
          Icon={CircleCloseIcon}
          color="red"
          topText={formatMoney(total.refunds, currency)}
          bottomText={t('report.workShifts.refunds')}
        />
        <SummaryBlock
          Icon={HandCoinIcon}
          color="green"
          topText={formatMoney(total.tips, currency)}
          bottomText={t('tips')}
        />
      </div>
      <Table data={summary} columns={COLUMNS} />
    </>
  );
};
